import * as React from 'react'
// components
import Header from '../components/layouts/Header'
import Footer from '../components/layouts/Footer'
import EnterpriseData from '../components/sections/Enterprise'

const Enterprise = () => (
  <>
    <div id='smooth-wrapper'>
      <div id='smooth-content'>
        <div className='podio enterprise-wrapper'>
          <EnterpriseData />
          <Footer />
        </div>
      </div>
    </div>
    <Header />
  </>
)

export default Enterprise
